




const ChallengeLogoSelection = ({ updateLogoSelection })  => {
    const thumbnail = process.env.PUBLIC_URL + "/images/trophies.jpg";
    const cartoonImg = process.env.PUBLIC_URL + "/images/cartoonTrophy.jpg";
    const gym = process.env.PUBLIC_URL + "/images/gym.jpg";
    const books = process.env.PUBLIC_URL + "/images/books.jpg"


    const style = {width: '100px', height: '100px', margin: '5px'}

    const handleChange = (e) => {
    const radioValue = e.target.value;
    updateLogoSelection(radioValue);
    }

    return (
    <div>
        <fieldset>
            <input type="radio" name="icon" value="TrophyA" onChange={handleChange} />
            <img alt={""} src={thumbnail} style={style}></img>
            <input type="radio" value="TrophyB" name="icon" onChange={handleChange} />
            <img alt={""} src={cartoonImg} style={style}></img>
            <input type="radio" value="TrophyC" name="icon" onChange={handleChange} />
            <img alt={""} src={gym} style={style}></img>
            <input type="radio" name="icon" value="BooksA" onChange={handleChange} />
            <img alt={""} src={books} style={style}></img>
        </fieldset>
    
    </div>
    )
    
}

export default ChallengeLogoSelection;